import React from 'react';
import { Content } from './shared';

const CignaJennyCraig = () => (
  <Content>
    Visit the Healthy Rewards page on the Cigna website and search for Jenny Craig to learn more.
  </Content>
);

export default CignaJennyCraig;
